import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalNav from '../../components/LegalNav';
import '../LegalPage.css';

function BlogIndex() {
  useEffect(() => {
    document.title = 'UK Tax Guide Articles & Resources - My Fair Share Blog';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert guides on UK tax, PAYE calculations, income tax bands, and take-home pay. Learn how to calculate your salary after tax with our comprehensive UK tax articles.');
    }
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Calculator</Link>
        
        <h1>UK Tax Calculator Guides & Resources</h1>
        <p className="last-updated">Expert guides on how alternative tax policies could reduce your tax burden</p>

        <section>
          <p>
            Welcome to the My Fair Share resource center. Did you know that alternative revenue sources like 
            taxing billionaires, closing corporate tax loopholes, and recovering Brexit costs could dramatically 
            reduce your income tax? Our guides show you exactly how much you could save if the government sourced 
            revenue more fairly instead of relying heavily on working people's income tax.
          </p>
        </section>

        <section>
          <h2>How Much Could You Save?</h2>
          
          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#ffffff'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/billionaire-tax-savings">
                How Taxing Billionaires Could Reduce Your UK Income Tax by 2%
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 9 minutes
            </p>
            <p>
              UK billionaires hold £619 billion in wealth. A modest wealth tax could generate £20bn annually and 
              reduce the basic income tax rate from 20% to 18%. For someone earning £40,000, that's £549 saved 
              every year. See the real calculations and understand why this matters for working people.
            </p>
            <Link to="/blog/billionaire-tax-savings" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>

          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#ffffff'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/brexit-cost-savings">
                What If Brexit Costs Were Removed? Your UK Tax Savings Explained
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 8 minutes
            </p>
            <p>
              Brexit costs the UK economy £40bn annually. If recovered, this could reduce the basic tax rate by 4% 
              - from 20% to 16%. That's £1,097 saved per year for someone earning £40,000. Discover how economic 
              inefficiency is costing you money and what could be done about it.
            </p>
            <Link to="/blog/brexit-cost-savings" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>

          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#ffffff'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/alternative-tax-sources">
                Alternative Tax Revenue Sources: How Much Could You Save?
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 12 minutes
            </p>
            <p>
              Comprehensive analysis of 10 alternative revenue sources totaling £121.3bn annually - enough to reduce 
              the basic tax rate from 20% to around 8%. From billionaire taxes to closing loopholes, discover how 
              fairer taxation could save you thousands per year. Includes detailed calculations for every salary level.
            </p>
            <Link to="/blog/alternative-tax-sources" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>
        </section>

        <section>
          <h2>Understanding UK Tax</h2>
          
          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#f9f9f9'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/uk-tax-calculator-guide">
                UK Tax Calculator Guide: How to Calculate Your Take-Home Pay in 2025
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 8 minutes
            </p>
            <p>
              A complete guide to using a UK tax calculator and understanding your take-home pay. Learn how income tax 
              bands work, how National Insurance is calculated, and see step-by-step examples for different salary levels.
            </p>
            <Link to="/blog/uk-tax-calculator-guide" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>

          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#f9f9f9'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/uk-tax-bands-guide">
                Understanding UK Tax Bands: Complete Guide for 2025-2026
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 10 minutes
            </p>
            <p>
              Everything you need to know about UK tax bands - the personal allowance, basic rate, higher rate, and 
              additional rate. Includes the crucial £100,000 personal allowance taper explained with real-world examples.
            </p>
            <Link to="/blog/uk-tax-bands-guide" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>

          <div className="blog-article-card" style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            backgroundColor: '#f9f9f9'
          }}>
            <h3 style={{marginTop: 0}}>
              <Link to="/blog/tax-on-30k-salary">
                How Much Tax Do I Pay on £30,000? Complete UK Salary Breakdown
              </Link>
            </h3>
            <p style={{color: '#666', fontSize: '14px', marginBottom: '10px'}}>
              Reading time: 7 minutes
            </p>
            <p>
              Detailed breakdown of tax on a £30,000 salary - one of the most common salary levels in the UK. See exactly 
              how much income tax and National Insurance you'll pay, with weekly, daily, and hourly breakdowns.
            </p>
            <Link to="/blog/tax-on-30k-salary" style={{
              color: '#1a365d',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Read the full guide →
            </Link>
          </div>
        </section>

        <section>
          <h2>Popular Topics</h2>
          <ul>
            <li><strong>Alternative Tax Sources:</strong> How billionaire taxes and closing loopholes could reduce your tax</li>
            <li><strong>Brexit Cost Impact:</strong> How Brexit affects your tax burden</li>
            <li><strong>Tax Fairness:</strong> Why workers pay more than wealth holders</li>
            <li><strong>UK Tax Calculation:</strong> How to work out your income tax and National Insurance</li>
            <li><strong>PAYE System:</strong> Understanding how Pay As You Earn works</li>
            <li><strong>Tax Bands 2025-2026:</strong> All the current rates and thresholds</li>
            <li><strong>Personal Allowance:</strong> Your tax-free income explained</li>
            <li><strong>Take-Home Pay:</strong> What you actually receive after deductions</li>
          </ul>
        </section>

        <section>
          <h2>About Our Guides</h2>
          <p>
            All our guides are:
          </p>
          <ul>
            <li><strong>Up to date:</strong> Using the latest 2025-2026 tax rates from HMRC</li>
            <li><strong>Accurate:</strong> Based on official government guidelines and regulations</li>
            <li><strong>Practical:</strong> Filled with real-world examples and calculations</li>
            <li><strong>Easy to understand:</strong> Written in plain English, no jargon</li>
            <li><strong>Free:</strong> All content is completely free with no paywalls</li>
          </ul>
        </section>

        <section>
          <h2>Try Our Free Tax Calculator</h2>
          <p>
            Reading about tax is helpful, but seeing your own numbers is even better. 
            <Link to="/"> Use our free UK tax calculator</Link> to instantly calculate:
          </p>
          <ul>
            <li>Your exact take-home pay</li>
            <li>Income tax breakdown by band</li>
            <li>National Insurance contributions</li>
            <li>Monthly, weekly, and daily earnings</li>
            <li>What-if scenarios for alternative tax policies</li>
          </ul>
          <p>
            Everything is calculated in real-time in your browser. We never store or share your salary information.
          </p>
        </section>

        <section>
          <h2>Have Questions?</h2>
          <p>
            If you have questions about UK tax that aren't covered in our guides, or if you'd like to suggest a topic 
            for a future article, please <Link to="/contact">get in touch</Link>. We're always looking to create content 
            that helps people understand their taxes better.
          </p>
        </section>

        <LegalNav />
      </div>
    </div>
  );
}

export default BlogIndex;
